import React from 'react'

export const SortArrowUpDown: React.FC<React.SVGProps<SVGSVGElement>> = (
   props
) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      {...props}
   >
      <g clipPath="url(#clip0_164_1360)">
         <path
            d="M6.60583 9.01498C6.89683 9.30948 6.89433 9.78448 6.59983 10.0755L4.70333 11.9505C4.46133 12.192 4.14283 12.3135 3.82383 12.3135C3.50483 12.3135 3.18283 12.192 2.93883 11.948L1.04533 10.076C0.750828 9.78498 0.748328 9.30998 1.03933 9.01548C1.33033 8.72048 1.80583 8.71848 2.10033 9.00948L3.07283 9.97098V1.04248C3.07283 0.62848 3.40833 0.29248 3.82283 0.29248C4.23733 0.29248 4.57283 0.62848 4.57283 1.04248V9.97098L5.54533 9.00948C5.84033 8.71848 6.31483 8.72048 6.60633 9.01548L6.60583 9.01498ZM12.0998 2.53098L10.2063 0.65898C9.71933 0.17148 8.92633 0.17148 8.44183 0.65598L6.54533 2.53098C6.25083 2.82198 6.24833 3.29698 6.53933 3.59148C6.83033 3.88648 7.30583 3.88848 7.60033 3.59748L8.57283 2.63598V11.5425C8.57283 11.9565 8.90833 12.2925 9.32283 12.2925C9.73733 12.2925 10.0728 11.9565 10.0728 11.5425V2.63548L11.0453 3.59698C11.1913 3.74148 11.3823 3.81398 11.5728 3.81398C11.7663 3.81398 11.9593 3.73998 12.1063 3.59148C12.3973 3.29698 12.3943 2.82198 12.0998 2.53098Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_164_1360">
            <rect
               width={12}
               height={12}
               fill="white"
               transform="translate(0.572266 0.29248)"
            />
         </clipPath>
      </defs>
   </svg>
)
